var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLatestReleasesHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M152.412 139.964C116 189.508 90.531 236.631 80.781 257.439A15.986 15.986 0 0 1 65.8 266.63l-16.051-.5c-38.573-1.182-56.218-48.87-27.61-74.87l59.21-53.84a88.123 88.123 0 0 1 57.84-22.9 16.006 16.006 0 0 1 13.223 25.444zm245.071 232.858a16.015 16.015 0 0 0-25.521-13.169C321.734 396.6 275 421.594 254.592 431.176a16.023 16.023 0 0 0-9.223 15l.5 16.079c1.184 38.627 48.914 56.181 74.87 27.61l53.84-59.21a88.119 88.119 0 0 0 22.904-57.833zM55.2 382.206l20.719-20.719a16 16 0 1 0-22.625-22.627l-20.719 20.719c-10.112 10.112-2.809 27.314 11.314 27.314a15.951 15.951 0 0 0 11.311-4.687zm98.016 98.016 20.721-20.722a16 16 0 0 0-22.628-22.627L130.59 457.6c-10.112 10.112-2.807 27.313 11.314 27.313a15.95 15.95 0 0 0 11.314-4.691zm-84.58-14.231 70.351-70.351a16 16 0 0 0-22.627-22.627l-70.351 70.351C35.9 453.476 43.2 470.678 57.322 470.678a15.951 15.951 0 0 0 11.314-4.687zM402.66 310.41a679.151 679.151 0 0 1-71.733 53.735 14.236 14.236 0 0 1-17.821-1.888L149.743 198.894a14.236 14.236 0 0 1-1.888-17.821 679.707 679.707 0 0 1 55.115-73.333 288.311 288.311 0 0 1 269.78-95.07l11.6 2.1a16.011 16.011 0 0 1 12.88 12.88l2.1 11.6c17.57 96.528-14.405 200.192-96.67 271.16zm-14.25-186.82a68.964 68.964 0 1 0 0 97.53 69.041 69.041 0 0 0 0-97.53zM138.224 232.628A14.23 14.23 0 0 0 115.58 236a684.263 684.263 0 0 0-8.85 17.4 52 52 0 0 0 9.96 59.69l82.22 82.22a52.052 52.052 0 0 0 36.83 15.27c14.154 0 22.512-4.821 40.262-14.16a14.23 14.23 0 0 0 3.37-22.644z",
    "data-name": "43. Start up",
    fill: "#6e44ff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatestReleasesHover);
export default __webpack_public_path__ + "static/media/latest-releases-hover.fcb67fa7e1985c1a530a885e2550f638.svg";
export { ForwardRef as ReactComponent };